export default "__VITE_ASSET__CiMqZ7wW__"